import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

export const list = (): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/collections');

export const owned = (): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/collections/owned');

export const sharedWithMe = (): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get('/api/collections/shared');

export const byTeam = (teamId: string): AxiosPromise<Types.IApi.List.Response> =>
  http.request.get(`/api/collections/team/${teamId}`);

export const single = (id: string): AxiosPromise<Types.IApi.Single.Response> =>
  http.request.get(`/api/collections/${id}`);

export const create = (data: Types.IApi.Create.Request): AxiosPromise<Types.IApi.Create.Response> =>
  http.request.post('/api/collections', data);

export const update = (id: string, data: Types.IApi.Update.Request): AxiosPromise<Types.IApi.Update.Response> =>
  http.request.patch(`/api/collections/${id}`, data);

export const remove = (id: string): AxiosPromise<void> =>
  http.request.delete(`/api/collections/${id}`);

export const addItem = (
  collectionId: string,
  data: Types.IApi.AddItem.Request
): AxiosPromise<Types.IApi.AddItem.Response> =>
  http.request.post(`/api/collections/${collectionId}/items`, data);

export const removeItem = (
  collectionId: string,
  data: Types.IApi.RemoveItem.Request
): AxiosPromise<void> =>
  http.request.delete(`/api/collections/${collectionId}/items`, { data });

export const share = (
  collectionId: string,
  data: Types.IApi.Share.Request
): AxiosPromise<Types.IApi.Share.Response> =>
  http.request.post(`/api/collections/${collectionId}/share`, data);

export const unshare = (
  collectionId: string,
  data: Types.IApi.Unshare.Request
): AxiosPromise<void> =>
  http.request.delete(`/api/collections/${collectionId}/share`, { data });
